import Registry from "../registry";
import React from "react";
import MarkdownEditor from "../components/fields/MarkdownEditor";
import CodeEditor from "../components/fields/CodeEditor";
import RichTextEditor from "../components/fields/RichTextEditor";
import { truncate } from "../lib/ContentUtils";

const content = {
  name: "Content",
  group: "Content",
  options: {
    default_value: { label: "Default choice" },
    editor_type: {
      label: "Editor Type",
      type: "string",
      allowedValues: {
        markdown: "Markdown",
        wysiwyg: "Rich Text",
        code: "Code"
      }
    }
  },
  schema: part => ({
    type: "string",
    component: ({ value, onChange, attrs: { id } }) => {
      let Component = MarkdownEditor;

      switch (part.editor_type) {
        case "code":
          Component = CodeEditor;
          break;
        case "wysiwyg":
          Component = RichTextEditor;
      }
      return <Component id={id} value={value} onChange={onChange} />;
    },
    render: ({ value }) => {
      if (part.editor_type === "wysiwyg") {
        const tmp = document.createElement("div");
        tmp.innerHTML = value;
        return truncate(tmp.textContent || tmp.innerText || "");
      }
      return truncate(value);
    }
  })
};

Registry.register("content", content);

export default content;



// WEBPACK FOOTER //
// ./app/parts/content.js